import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExcetionLogsComponent } from './excetion-logs.component';

const routes: Routes = [
    {
        path: '', component: ExcetionLogsComponent
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExcetionLogsRoutingModule { }
